import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toast, ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage from '../assets/lgbg.jpg';
import { useEffect } from 'react';
const CreateCandidateExitsAccount = () => {
  const [submitted, setSubmitted] = useState(false);
  const [hrUsername, setHrUsername] = useState("");

  const schema = yup.object().shape({
    username: yup
      .string()
      .required('Full Name is required')
      .matches(/^[a-zA-Z ]+$/, 'Only letters are allowed for Name')
      .min(1, 'Name must be at least 2 characters')
      .max(50, 'Name must be at most 20 characters'),
      EmployeeID: yup.string().required('Employee ID is required'),
      email: yup
      .string()
      .required('Email is required')
      .email('Email must be valid')
      .test('not-gxinetworks', 'Emails with @gxinetworks.com are not allowed', value => {
        return !value || !value.endsWith('@gxinetworks.com');
      }),
    
    
    password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
    Date_of_Release:yup.string().required('Date of Releasing is required'),
    
    // hrUsername: yup.string().required('HR Username is required'), // HR username required field
  });

  useEffect(() => {
    const hrUser = document.cookie
      .split(";")
      .find((cookie) => cookie.trim().startsWith("userName="))
      ?.split("=")[1];
    if (hrUser) setHrUsername(hrUser);
  }, []);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  //http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000

  const onSubmit = async (data) => {
    try {
      // Include the HR username in the form data
      const formData = { ...data, hrUsername };
  
      const response = await fetch('http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/CreateEmployeeExitsAccount', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        toast.success('Employee exit account created successfully', {
          position: 'top-center',
          transition: Slide,
        });
        reset();
        setSubmitted(true);
      } else {
        toast.error(responseData?.message || 'An error occurred');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to submit form. Please try again later.');
    }
  };
  

  return (
    <>
      <ToastContainer />
      <div
        className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="bg-white bg-opacity-10 p-5 rounded-xl shadow-lg max-w-md w-full mt-5 mb-3">
          <h2 className=" text-lg font-bold mb-4 text-center text-white">Create Exit Employee Account </h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-2">
              <label className="block text-white mb-2 font-medium text-sm">Candidate Username</label>
              <input
                type="text"
                {...register('username')}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.username && <p className="text-red-500 text-sm mt-1">{errors.username.message}</p>}
            </div>

            <div className="mb-2">
              <label className="block text-white mb-2 font-medium text-sm">Employee ID</label>
              <input
                type="text"
                {...register('EmployeeID')}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.EmployeeID && <p className="text-red-500 text-sm mt-1">{errors.EmployeeID.message}</p>}
            </div>

            <div className="mb-2">
              <label className="block text-white mb-2 font-medium text-sm">Last Working Day</label>
              <input
                type="date"
                {...register('Date_of_Release')}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.Date_of_Release && <p className="text-red-500 text-sm mt-1">{errors.Date_of_Release.message}</p>}
            </div>


            <div className="mb-2">
              <label className="block text-white mb-2 font-medium text-sm">Personal Email</label>
              <input
                type="email"
                {...register('email')}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
            </div>

            

            <div className="mb-2">
              <label className="block text-white mb-2 font-medium text-sm">Password</label>
              <input
                type="password"
                {...register('password')}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>}
            </div>


          



          

            

            <button
              type="submit"
              className="w-full bg-primary text-sm text-white py-2 rounded-lg mt-3 hover:bg-primary-dark transition duration-300"
            >
              Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateCandidateExitsAccount;
